import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import useReportFiltersFetch from "../../../../hooks/use-report-filters-fetch.js";
import InputCheckbox from "../../../../components/input/input-checkbox.jsx";
import TimePeriodInput from "../../../../components/reports/time-period-input/time-period-input.jsx";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters }) => {
    const { dispatchQualityUser } = useReportFiltersFetch({ fetchDispatchQualityUser: true} );

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>

                    <InputDateTime
                        id="dtStart"
                        label="Data inicial *"
                        selected={filters.dtStart}
                        onChange={(date) => setFilters(prev => ({...prev, dtStart: date}))}
                        classNameWrapper={"w-full"}
                        dateFormat="L"
                    />

                    <InputDateTime
                        id="dtEnd"
                        label="Data final *"
                        selected={filters.dtEnd}
                        onChange={(date) => setFilters(prev => ({...prev, dtEnd: date}))}
                        classNameWrapper={"w-full"}
                        dateFormat="L"
                    />

                    <TimePeriodInput filters={filters} setFilters={setFilters} singleRow={true}/>

                    <SelectComponent
                        id="dispatch"
                        label='Despacho'
                        isMulti={false}
                        options={[
                            {label: "Todos", value: 'all'},
                            {label: "Principal", value: 'main'},
                            {label: "Apoio", value: 'support'}
                        ]}
                        value={filters.dispatch}
                        onChange={(value) => setFilters(prev => ({...prev, dispatch: value}))}
                        classNameWrapper={"w-full"}
                        isClearable={false}
                    />

                    <SelectComponent
                        id="options"
                        label='Indicadores de preenchimento *'
                        isMulti={true}
                        wrapValues={true}
                        options={[
                            {label: "Bairro", value: 'factneighborhood'},
                            {label: "Latitude/Longitude", value: 'factlatitude'},
                            {label: "Local pré-cadastrado", value: 'factplace'},
                            {label: "Logradouro", value: 'factstreet'},
                            {label: "Natureza", value: 'nature'},
                            {label: "Número", value: 'factnumber'},
                            {label: "Observação", value: 'observation'},
                            {label: "Observação final", value: 'finalobservation'},
                            {label: "Setor", value: 'sectors'},
                        ]}
                        value={filters.options}
                        onChange={(value) => setFilters(prev => ({...prev, options: value}))}
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        id="user"
                        label='Agentes'
                        isMulti={true}
                        wrapValues={true}
                        options={dispatchQualityUser}
                        value={filters.user}
                        onChange={(value) => setFilters(prev => ({...prev, user: value}))}
                        classNameWrapper={"w-full"}
                    />

                    <InputCheckbox
                        id="dispatchList"
                        label="Listar despachos"
                        className='ml-1'
                        checked={filters.dispatchList}
                        onChange={(e) => setFilters(prev => ({...prev, dispatchList: e.target.checked}))}
                    />

                </form>
            </div>
        </>
    );
};

export default Filters;